export * as IconsNocowanie from './index.icon';
